import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';

import CurrencyConverter from '../../CurrencyConverter';

import messages from '../../../locale/jsonMessages';

import cs from '../../commonStyle.css';
import s from '../ViewMessage.css';

const HostEarnings = (props) => {

    const { hostEarnings, currency } = props;

    return (
        <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
            <div className={cx(cs.commonSmallText18, cs.fontWeightBold, cs.textStart)}>
                <FormattedMessage {...messages.youEarn} />
            </div>
            <div className={cx(cs.commonSmallText18, cs.fontWeightBold, cs.textEnd)}>
                <CurrencyConverter amount={hostEarnings} from={currency} />
            </div>
        </div>
    );
}

export default withStyles(cs, s)(HostEarnings);

